const timeDiffInDays = (now, time) => Math.round(Math.abs(now - time) / (1000 * 60 * 60 * 24));

const cleanLocalitiesArray = (loc) => loc.substring(1, loc.length - 1).split('|');

const localityLogic = (storageLoc, rizLoc) => {
  // ricevo stringhe strutturate in questo modo:
  // |codiceLocalità| o |codiceLocalità1|codiceLocalità2|codiceLocalitàN|
  // le trasformo in array di stringhe ['codiceLocalità'] o
  // ['codiceLocalità1', 'codiceLocalità2', 'codiceLocalitàN']
  // per confrontarle
  const cleanStLocSet = cleanLocalitiesArray(storageLoc);
  const cleanRizLocSet = cleanLocalitiesArray(rizLoc);

  // i due set contengono un'unica località
  if (cleanStLocSet.length === 1 && cleanRizLocSet.length === 1) {
    // controllo se i codici sono uguali
    return cleanStLocSet[0] === cleanRizLocSet[0];
  }

  // il set salvato nello storage ha più di una località
  // e la riz ha una sola località
  if (cleanStLocSet.length > 1 && cleanRizLocSet.length === 1) {
    // controllo se il set salvato nello storage contiene
    // il codice della località della riz
    return cleanStLocSet.includes(cleanRizLocSet[0]);
  }

  // i due set contengono lo stesso numero di località
  // necessariamente superiore a 1
  if (cleanStLocSet.length === cleanRizLocSet.length) {
    // controllo se i due set contengono gli stessi elementi
    return cleanStLocSet.every((x) => cleanRizLocSet.includes(x));
  }

  return false;
};

export default function blockRizLogic(
  rizStorageArray,
  rizData,
  config = {
    discardIfOlderThan: 0,
    blockIfOlderThan: 30,
  },
) {
  let shouldRizBeBlocked = false;
  const now = Date.now();
  // se la configurazione discardIfOlderThan è definita e diversa da zero
  // il nuovo array di riz salvate è un subset di quello originale
  // contenente i record più recenti del valore di discardIfOlderThan
  const newRizStorageArray = config.discardIfOlderThan
    ? rizStorageArray.filter(
      (storageRecord) => timeDiffInDays(now, storageRecord.time) <= config.discardIfOlderThan,
    ) : rizStorageArray;

  if (newRizStorageArray.length) {
    // controllo se nel record salvato sullo storage esiste una riz inviata con
    // le stesse caratteristiche salienti di quella che viene inviata ora
    const exists = newRizStorageArray.map(
      (storageRecord, index) => {
        if (
          storageRecord.email === rizData.email
          && storageRecord.channel === rizData.channel
          && storageRecord.category === rizData.category
          && storageRecord.propertyTypeGroup === rizData.propertyTypeGroup
          && localityLogic(storageRecord.locationCode, rizData.locationCode)
        ) {
          return {
            item: storageRecord,
            index,
          };
        }
        return null;
      },
    ).filter(Boolean)[0];
    if (exists) {
      // se esiste ed è stata inviata entro una settimana, non ne devo poter inviare un'altra
      shouldRizBeBlocked = timeDiffInDays(now, exists.item.time) <= config.blockIfOlderThan;
      // se non deve essere bloccata in questo momento perchè più vecchia del valore
      // della configurazione blockIfOlderThan, rimuovo l'entry corrente
      //  e la aggiungo con la data aggiornata
      if (!shouldRizBeBlocked) {
        newRizStorageArray.splice(exists.index, 1);
        newRizStorageArray.push({
          ...rizData,
          time: now,
        });
      }
    } else {
      // se non esiste la aggiungo alla lista di quelle da bloccare
      // aggiungendo il timestamp ai dati
      newRizStorageArray.push({
        ...rizData,
        time: now,
      });
    }
  } else {
    // se il record salvato sullo storage è vuoto, salvo la riz corrente
    // aggiungendo il timestamp ai dati
    newRizStorageArray.push({
      ...rizData,
      time: now,
    });
  }
  return {
    shouldRizBeBlocked,
    newRizStorageArray,
  };
}
